import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const PageWrapper = styled.div`
  background-color: #fff;
  color: #3c4043;
  font-family: 'Roboto', 'Arial', sans-serif;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

const HeaderContainer = styled.div`
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 100;
  border-bottom: 1px solid #dadce0;
  width: 100%;
`;


const TopBar = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 32px;
`;

const Logo = styled.div`
  font-size: 22px;
  font-weight: 400;
  color: #5f6368;
`;

const MainHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 0 16px; 
`;

const ToggleButton = styled.button`
  font-size: 15px;
  color: ${props => (props.active ? '#1a73e8' : '#5f6368')};
  background: none;
  border: none;
  padding: 16px;
  cursor: pointer;
  border-bottom: ${props => (props.active ? '3px solid #1a73e8' : '3px solid transparent')};
  font-weight: 500;
  transition: color 0.2s, border-color 0.2s;
  &:hover { color: #1a73e8; }
  
`;

const HeroTitle = styled.h1`
  font-size: 36px;
  font-weight: 400;
  color: #202124;
  margin: 16px 0;
`;

const HeroParagraph = styled.p`
  font-size: 16px;
  line-height: 1.7;
  color: #5f6368;
  max-width: 720px; 
`;

const DummyNavItem = styled.span`
  font-size: 15px;
  color: #5f6368;
  padding: 16px;
  cursor: not-allowed;
`;

const Content = styled.div`
  display: flex;
  flex-grow: 1;
  width: 100%; 
`;

const Sidebar = styled.aside`
  width: 280px;
  padding: 48px 16px 48px 32px;
  flex-shrink: 0;
  position: sticky;
  top: 126px;
  align-self: flex-start;
  max-height: calc(100vh - 126px);
  overflow-y: auto;
  border-right: 1px solid #dadce0;
`;

const SideList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const SideItem = styled.li` margin-bottom: 4px; `;

const SideLink = styled.a`
  display: block;
  font-size: 14px;
  color: ${props => (props.active ? '#1967d2' : '#5f6368')};
  text-decoration: none;
  font-weight: ${props => (props.active ? '500' : '400')};
  padding: 10px 16px;
  border-radius: 4px;
  border-left: ${props => (props.active ? '3px solid #1967d2' : '3px solid transparent')};
  transition: background-color 0.2s, color 0.2s, border-left 0.2s;
  &:hover { background-color: #f1f3f4; color: #202124; }
`;

const Main = styled.main`
  flex: 1;
  padding: 48px 64px 64px 64px;
`;

const IntroGraphic = styled.div`
    // UPDATED: No longer centered
    margin-bottom: 32px;
    svg {
        height: 100px;
        width: 100px;
    }
`;

const IntroSection = styled.div`
  padding-top: 16px;
  margin-bottom: 48px;
`;


const Metadata = styled.div`
  font-size: 14px;
  color: #5f6368;
  text-align: left;
  margin-bottom: 48px;
  & a {
    color: #1a73e8;
    text-decoration: none;
    &:hover { text-decoration: underline; }
  }
`;

const MainContentTitle = styled.h2`
  font-size: 28px;
  font-weight: 500;
  color: #202124;
  margin-bottom: 16px;
`;

const Section = styled.section` 
  margin-bottom: 48px;
  padding-top: 16px; 
`;

const SectionTitle = styled.h2` 
  font-size: 24px; 
  font-weight: 500; 
  color: #202124;
  margin-bottom: 24px; 
  padding-bottom: 8px;
  border-bottom: 1px solid #e8eaed;
`;

const Paragraph = styled.p` 
  font-size: 14px; 
  line-height: 1.8;
  margin-bottom: 16px; 
  color: #3c4043;
`;

const termsContent = [
    { id: "AcceptanceOfTerms", title: "1. Acceptance of Terms", text: "By accessing or using the services provided by Candidate Tools INC (\"Company\", \"we\", \"our\", or \"us\"), including any applications, content, functionality, or services offered on or through our website (the \"Service\"), you agree to be bound by these Terms of Service (\"Terms\"). If you do not agree to these Terms, you may not access or use the Service. These Terms apply to all visitors, users, and others who access or use the Service." },
    { id: "DescriptionOfService", title: "2. Description of Service", text: "Our Service is a subscription-based software platform delivered via the internet that enables users to streamline the hiring process by automatically prescreening, scoring, and ranking candidates using AI and proprietary algorithms. It converts unstructured data into structured, actionable profiles, allowing hiring teams to quickly identify top-performing candidates—often the top 2%—based on client-specific criteria. The platform emphasizes fairness and efficiency by incorporating bias analysis, enabling human oversight in decision-making, and operating without reliance on traditional resumes. Ideal for organizations managing high application volumes, Candidate Tools enhances hiring precision while reducing time spent on manual screening. The Service is provided on an \"as is\" and \"as available\" basis and may be updated or changed at any time without prior notice." },
    { id: "UserAccount", title: "3. User Account", text: "To use certain features of the Service, you must create an account. You agree to provide accurate, complete, and current information during registration and to keep your information up to date. You are responsible for safeguarding your password and any activities under your account. You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account." },
    { id: "SubscriptionBillingPayment", title: "4. Subscription, Billing, and Payment", text: "Access to certain parts of the Service may require payment. Subscription plans are billed on a recurring basis in advance (monthly, annually, etc.) and renew automatically unless cancelled. By providing a payment method, you authorize us to charge you for the agreed amounts. Refunds are issued at our discretion, and only in accordance with our Refund Policy." },
    { id: "UserConduct", title: "5. User Conduct and Responsibilities", text: "You agree not to misuse the Service, including but not limited to: Engaging in illegal, fraudulent, or deceptive practices. Attempting to reverse-engineer, decompile, or gain unauthorized access. Transmitting viruses, malware, or other harmful content. Using the Service in a manner that interferes with its normal operation or the use of the Service by others." },
    { id: "IntellectualProperty", title: "6. Intellectual Property", text: "All intellectual property rights in the Service, including but not limited to software, text, graphics, logos, and trademarks, are owned by Candidate Tools INC or its licensors. You are granted a limited, non-exclusive, non-transferable license to use the Service for your personal or internal business purposes in accordance with these Terms." },
    { id: "PrivacyDataProtection", title: "7. Privacy and Data Protection", text: "Your privacy is important to us. Our collection and use of personal data is governed by our Privacy Policy. By using the Service, you consent to the collection, use, and disclosure of your information as described therein. You retain ownership of any content or data you upload, but grant us a license to use it as necessary to provide the Service." },
    { id: "Termination", title: "8. Termination", text: "We reserve the right to suspend or terminate your access to the Service at any time, without notice or liability, if you breach these Terms. You may cancel your subscription at any time. Upon termination, your right to use the Service will immediately cease." },
    { id: "Disclaimers", title: "9. Disclaimers and Warranties", text: "The Service is provided \"as is\" and \"as available\" without warranty of any kind. We disclaim all warranties, whether express or implied, including but not limited to merchantability, fitness for a particular purpose, and non-infringement. We do not guarantee the Service will be uninterrupted, secure, or error-free." },
    { id: "LimitationOfLiability", title: "10. Limitation of Liability", text: "To the fullest extent permitted by law, Candidate Tools INC shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, resulting from your access to or use of the Service." },
    { id: "Modifications", title: "11. Modifications to the Terms", text: "We may revise these Terms at any time by posting an updated version on our website. Continued use of the Service after changes become effective constitutes your acceptance of the new Terms. We encourage you to review the Terms periodically." },
    { id: "GoverningLaw", title: "12. Governing Law", text: "These Terms shall be governed by and construed in accordance with the laws of Oklahoma, without regard to its conflict of law principles. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the courts located in Oklahoma." },
    { id: "Contact", title: "13. Contact Information", text: "For any questions or concerns regarding these Terms, please contact us at info@candidatetools.com." }
];



const privacyContent = [
    { id: "Introduction", title: "1. Introduction", text: "Candidate Tools (“Company”, “we”, “our”, or “us”) is committed to protecting your privacy. This Privacy Policy outlines how we collect, use, process, disclose, and safeguard your information when you visit our website or use our web-based services (collectively, the “Service”). This policy is designed to help you understand your rights and choices, and how you can exercise them in compliance with applicable privacy laws including, where applicable, the California Consumer Privacy Act (CCPA), the General Data Protection Regulation (GDPR), and other similar regulations. By accessing or using our Service, you acknowledge that you have read and understood this Privacy Policy. If you do not agree with the practices described herein, you should not use the Service." },
    { id: "InformationWeCollect", title: "2. Information We Collect", text: "We may collect and process the following categories of information: Personal Information: Identifiable data such as your name, email address, company name, phone number, and other information you provide during account registration or usage of our Service. Candidate Data: Any content or documents (including resumes, profiles, and assessments) you upload or transmit through the Service, which may contain personal data of third parties. Technical and Usage Data: Information collected automatically through cookies, server logs, and similar technologies, including IP address, browser type, operating system, device identifiers, pages visited, time spent, and referring URLs. Payment Information: Billing details and payment method information (collected and processed by our third-party payment processors (Stripe))." },
    { id: "LegalBasis", title: "3. Legal Basis for Processing", text: "We process your information under the following lawful bases: Consent; Performance of a contract; Compliance with legal obligations; Legitimate interests (e.g., to improve the Service, ensure security, or conduct analytics)." },
    { id: "UseOfInformation", title: "4. Use of Information", text: "Your information may be used for the following purposes: To provide, maintain, and improve the Service; To process transactions and manage subscriptions; To personalize user experiences; To send administrative information and respond to inquiries; To ensure compliance with applicable laws, regulations, and our contractual obligations; To detect, prevent, and address technical issues, abuse, or fraud." },
    { id: "DataSharing", title: "5. Data Sharing and Disclosure", text: "We do not sell, rent, or trade personal information. We may share information with: Service Providers: Third-party vendors, consultants, and contractors who perform services on our behalf under confidentiality agreements. Affiliates and Corporate Transactions: In the event of a merger, acquisition, restructuring, or asset sale, user data may be transferred as part of the transaction. Legal Compliance: Where required by law or pursuant to legal process, including responding to lawful requests by public authorities." },
    { id: "DataRetention", title: "6. Data Retention", text: "We retain your personal information only for as long as necessary to fulfill the purposes outlined in this Privacy Policy or as required by law. This includes retention for accounting, reporting, and compliance obligations." },
    { id: "DataSecurity", title: "7. Data Security", text: "We implement industry-standard technical and organizational measures to protect your personal data against unauthorized access, disclosure, alteration, or destruction. While we strive to protect your information, we cannot guarantee absolute security." },
    { id: "YourRights", title: "8. Your Rights and Choices", text: "Depending on your jurisdiction, you may have the following rights: Right to access and obtain a copy of your data; Right to rectification or erasure of your data; Right to restrict or object to processing; Right to data portability; Right to withdraw consent at any time (without affecting prior processing); Right to lodge a complaint with a supervisory authority. To exercise any of these rights, please contact us at info@candidatetools.com." },
    { id: "InternationalTransfers", title: "9. International Data Transfers", text: "Your personal information may be stored and processed in any country where we or our service providers maintain facilities. If you are located outside of the United States, your information may be transferred to jurisdictions that may not provide equivalent levels of data protection. We will take appropriate measures to ensure that such transfers comply with applicable privacy laws." },
    { id: "ChildrensPrivacy", title: "10. Children's Privacy", text: "Our Service is not directed toward individuals under the age of 13, and we do not knowingly collect personal data from children. If we learn that we have collected data from a minor without verifiable parental consent, we will delete such information." },
    { id: "ChangesToPolicy", title: "11. Changes to This Privacy Policy", text: "We reserve the right to amend this Privacy Policy at our discretion and at any time. When changes are made, we will post the updated policy on this page and update the “Effective Date” at the top. Your continued use of the Service after the revised policy becomes effective constitutes your acknowledgment and acceptance." },
    { id: "ContactUs", title: "12. Contact Us", text: "If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at: Candidate Tools Email: info@candidatetools.com" }
];

// --- Custom Hook for Scroll Spy ---
function useScrollSpy(ids, options) {
    const [activeId, setActiveId] = useState(ids[0] || '');
    const observer = useRef(null);

    useEffect(() => {
        if (observer.current) observer.current.disconnect();
        observer.current = new IntersectionObserver(entries => {
            const visibleSection = entries.find(entry => entry.isIntersecting);
            if (visibleSection) setActiveId(visibleSection.target.id);
        }, options);

        const elements = ids.map(id => document.getElementById(id));
        elements.forEach(el => {
            if (el) observer.current.observe(el);
        });

        return () => {
            if (observer.current) observer.current.disconnect();
        };
    }, [ids, options]);

    return activeId;
}

// --- Layout Component ---
function LegalPageLayout({ pageType }) {
  const content = pageType === 'privacy' ? privacyContent : termsContent;
  const heroText = pageType === 'privacy'
    ? "When you use our services, you’re trusting us with your information. We understand this is a big responsibility and work hard to protect your information and put you in control."
    : "These Terms of Service help define Candidate Tools' relationship with you as you interact with our services. Understanding these terms is important because, by using our services, you’re agreeing to these terms.";
  const heroTitle = pageType === 'privacy' ? "Privacy Policy" : "Terms of Service";
  const ids = content.map(item => item.id);
  const activeSection = useScrollSpy(ids, { rootMargin: '-20% 0px -80% 0px' });

  useEffect(() => {
      window.scrollTo(0, 0);
  }, [pageType]);

return (
    <>
        <Sidebar>
            <SideList>
                {content.map(item => (
                    <SideItem key={item.id}>
                        <SideLink href={`#${item.id}`} active={activeSection === item.id}>
                            {item.title}
                        </SideLink>
                    </SideItem>
                ))}
            </SideList>
        </Sidebar>
        <Main>
            <IntroSection>
                    <IntroGraphic>
                            <svg focusable="false" width="100" height="100" viewBox="0 0 160 160"><g clip-path="url(#a)"><path fill="none" stroke="#D1E2FC" stroke-width="2" d="M80 128.3a48.3 48.3 0 100-96.6 48.3 48.3 0 000 96.6z"></path><path fill="#E8F0FE" d="M80 126.5a46.5 46.5 0 100-93 46.5 46.5 0 000 93z"></path><path fill="#D2E3FC" d="M80 80l-33.1 33.1c18.3 18.2 47.9 18.2 66.2 0L80 80z"></path><path fill="#4285F4" d="M106.3 53.7A37 37 0 0053.7 106.3a37 37 0 0052.6-52.6z"></path><path fill="#FFF" d="M99.5 60.5a27.6 27.6 0 00-39 0 27.6 27.6 0 0039 0z"></path><path fill="#4285F4" d="M80 80L62.7 62.7a24.5 24.5 0 00-9.8 19.4 24.5 24.5 0 0019.4 9.8L80 80z"></path><path fill="none" stroke="#4285F4" stroke-width="2" d="M125.7 80a45.8 45.8 0 01-13.4 32.4m-64.6 0A45.8 45.8 0 0134.3 80m45.4-45.7c18 0 32.9 14.6 32.9 32.6 0 5.4-1.3 10.4-3.7 14.8"></path><g><path fill="#FFF" d="M120.2 110.1l-6.1-2.9a1.5 1.5 0 00-2 1.3v6a1.5 1.5 0 001.5 1.5h4.1a1.5 1.5 0 001.5-1.5v-1.5c0-.8-.7-1.5-1.5-1.5h-1z"></path><path fill="#EA4335" d="M114.1 114.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7z"></path><circle cx="114.1" cy="111" r="2" fill="#FFF"></circle></g><g><path d="M57.5 56.6l-11.4-1.9a1.5 1.5 0 00-1.7 1.2l-1 6a1.5 1.5 0 001.2 1.7l11.4 1.9a1.5 1.5 0 001.7-1.2l1-6a1.5 1.5 0 00-1.2-1.7z" fill="#FBBC05"></path><path d="M48.2 63.8c-.8 0-1.5-.7-1.5-1.5v-7c0-.8.7-1.5 1.5-1.5.8 0 1.5.7 1.5 1.5v7c0 .8-.7 1.5-1.5 1.5z" fill="#FFF"></path><path d="M48.2 63.8a1.5 1.5 0 010-3h0a1.5 1.5 0 010 3z" fill="#FCEEC4"></path></g><g><path d="M109.5 40.5l-6-1.5a1.5 1.5 0 00-1.6.8l-3.3 5.4a1.5 1.5 0 00.8 2l6 1.5a1.5 1.5 0 001.6-.8l3.3-5.4a1.5 1.5 0 00-.8-2z" fill="#34A853"></path><path d="M101.4 46.9l.4-.2-2.3-3.9.4-.2c.4-.2.8-.1 1.1.2l2.9 4.7c.3.4.2.9-.2 1.1l-.4.2c-.4.3-.9.2-1.1-.2l-2.4-3.9-.4-.2z" fill="#FFF"></path><path d="M102.5 49.3c.4 0 .8-.4.8-.8v-1.6c0-.4-.4-.8-.8-.8-.5 0-.8.4-.8.8v1.6c0 .4.3.8.8.8z" fill="#FFF"></path></g></g></svg>
                    </IntroGraphic>
                    <HeroTitle>{heroTitle}</HeroTitle>            
                    <HeroParagraph>{heroText}</HeroParagraph>

                    <Metadata>
                            <b>Effective June 20, 2025 &nbsp;|&nbsp; </b>
                    </Metadata>
                    <MainContentTitle>What's covered in these terms</MainContentTitle>
            </IntroSection>
            {content.map(item => (
                <Section key={item.id} id={item.id} style={{ scrollMarginTop: '120px' }}>
                    <SectionTitle>{item.title}</SectionTitle>
                    <Paragraph>{item.text}</Paragraph>
                </Section>
            ))}
        </Main>
    </>
);
}

// --- Main Component ---
export default function LegalPages() {
  const [pageType, setPageType] = useState('terms');

const navigate = useNavigate();

return (
    <PageWrapper>
        <HeaderContainer>
            <TopBar>
                <Logo
                    style={{ cursor: 'pointer' }}
                    onClick={() => navigate('/')}
                >
                    <img
                        src={process.env.PUBLIC_URL + '/ct_logo_black.png'}
                        alt="Candidate Tools Logo"
                        style={{ height: 48, verticalAlign: 'middle' }}
                    />
                </Logo>
            </TopBar>
            <MainHeader>
                <ToggleButton active={pageType === 'privacy'} onClick={() => setPageType('privacy')}>Privacy Policy</ToggleButton>
                <ToggleButton active={pageType === 'terms'} onClick={() => setPageType('terms')}>Terms of Service</ToggleButton>
            </MainHeader>
        </HeaderContainer>
        <Content>
            <LegalPageLayout pageType={pageType} />
        </Content>
    </PageWrapper>
);
}
